import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const TimeLineStyle = {
  blockCalendar: css`
    display: flex;
    gap: 8px;
  `,
  buttonCalendar: (isSelect: boolean) => css`
    /* border: 1px solid ${isSelect
      ? theme.colors.darkGreen
      : "transparent"}; */
    padding: 12px 48px;
    border-radius: 8px;
    margin-top: 16px;
    color: ${isSelect ? theme.colors.white : theme.colors.gray[200]};
    background-color: ${isSelect
      ? theme.colors.darkGreen
      : theme.colors.gray[150]};
    cursor: pointer;
  `,
  fromGroupContainer: () => css`
    display: flex;
    gap: 8px;
    align-items: center;
    margin: 16px 0;

    ${media.sm} {
      flex-wrap: wrap;
      gap: 0;
      /* justify-content: center; */
      justify-content: space-between;
    }
  `,
  formGroup: () => css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 160px;
    width: calc(20% - 8px);

    ${media.xl} {
      width: calc(50% - 8px);
    }
  `,
  spanDate: (colorContent: string) => css`
    color: ${colorContent};
  `,
  iconCalendar: () => css`
    color: ${theme.colors.darkGreen};
  `,
  fromDash: () => css`
    display: flex;
    flex-direction: column;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    gap: 8px;
    span {
      &:first-of-type {
        color: transparent;
      }
      color: ${theme.colors.white};
    }

    ${media.md} {
      color: ${theme.colors.black};
    }
    ${media.sm} {
      color: ${theme.colors.black};
    }
  `,
  formSubmit: css`
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-left: 8px;
    gap: 8px;
    ${media.sm} {
      margin-left: 0;
      margin-top: 16px;
      width: 100%;
    }
  `,
  blockEmpty: () => css`
    color: transparent;
  `,
  btnSubmit: () => css`
    min-width: 120px;
    height: 44px !important;
    font-weight: 400;
    background: ${theme.colors.gradient[1]};
    span {
      color: ${theme.colors.text.buttonActive};
      font-weight: 600;
    }

    ${media.sm} {
      min-width: 0;
      width: 100%;
    }
  `,
};
